import { getCurrentUser } from 'ducks/users'
import { useSelector } from 'react-redux'

export default function useDebugMode(): boolean {
  const currentUser = useSelector(getCurrentUser)

  return Boolean(currentUser?.admin)
}
